import posthog from 'posthog-js'

const POSTHOG_KEY = 'phc_CCmLyPAEKhQZva8RzpMyF4r3zRzRxNDRbMTraFyTAqBy'

let initialized = false

export function initPostHog() {
  if (typeof window === 'undefined') return posthog
  if (initialized) return posthog
  initialized = true

  // Bootstrap from server-rendered Clerk distinctID if present.
  // Server layout injects window.__PH_BOOTSTRAP__ = { distinctID, isIdentifiedID }.
  // Falls back to anonymous if not injected (Clerk auth() unavailable or unauthed).
  const bootstrap =
    (typeof window !== 'undefined' &&
      (window as unknown as { __PH_BOOTSTRAP__?: { distinctID?: string; isIdentifiedID?: boolean } }).__PH_BOOTSTRAP__) ||
    undefined

  posthog.init(POSTHOG_KEY, {
    api_host: '/api/ingest',
    ui_host: 'https://eu.i.posthog.com',
    defaults: '2025-05-24',
    // identified_only: anonymous events still capture but don't burn a person
    // profile each. Profiles are created on identify(). Big savings on
    // PostHog person quota for a marketing landing page.
    person_profiles: 'identified_only',
    capture_pageview: 'history_change',
    capture_pageleave: true,
    capture_exceptions: true,
    autocapture: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: { password: true },
    },
    bootstrap,
    loaded: (ph) => {
      if (process.env.NODE_ENV === 'development') {
        ph.debug(false)
      }
    },
  })

  return posthog
}

// Init at module load on the client. Eliminates the parent/child effect race
// that previously dropped the first `/` pageview before the provider mounted.
if (typeof window !== 'undefined') {
  initPostHog()
}

export { posthog }
